import { ClipHttpStatus } from "@apis/http/types";
import { TestId } from "@shared/testIds";
import { ClipErrorCode } from "@utils/errrorMessage";
import classNames from "classnames";
import { Trans } from "react-i18next";

export interface ParseErrorTipProps {
  status: ClipHttpStatus;
  code: ClipErrorCode | undefined;
  error?: string | null;
  onTryUploadImage: () => void;
  onExtractVideoScript: () => void;
}

export const ParseErrorTip = (props: ParseErrorTipProps) => {
  const { status, code, error, onTryUploadImage, onExtractVideoScript } = props;
  const isVideoLink = code === ClipErrorCode.KALODATA_UNSUPPORTED_LINK;
  const isStorageQuotaExceeded = code === ClipErrorCode.ASSET_STORAGE_QUOTA_EXCEEDED;

  return (
    <div
      data-testid={TestId.VideoCreateParseErrorTip}
      className={classNames(
        "w-[800px] text-kds-danger text-[14px] font-normal",
        status === "failed" ? "" : "invisible",
      )}
    >
      *{" "}
      {isStorageQuotaExceeded && error ? (
        error
      ) : (
        <Trans
          components={{
            span: (
              <span
                className="text-kds-fg cursor-pointer underline"
                onClick={isVideoLink ? onExtractVideoScript : onTryUploadImage}
              />
            ),
          }}
          defaults={
            isVideoLink
              ? "This is a video link, not a product link. Did you mean to use <span>Video to Script</span>?"
              : "Unable to retrieve product information. Please <span>Try to upload an image</span>"
          }
        ></Trans>
      )}
    </div>
  );
};
